var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7702 0.485352H2.90356C1.81084 0.485352 0.925781 1.37041 0.925781 2.46313V18.2853C0.925781 19.3781 1.81084 20.2631 2.90356 20.2631H14.7702C15.8629 20.2631 16.748 19.3781 16.748 18.2853V2.46313C16.748 1.37041 15.8629 0.485352 14.7702 0.485352ZM8.83688 4.4409C10.518 4.4409 11.8035 5.72646 11.8035 7.40757C11.8035 9.08868 10.518 10.3742 8.83688 10.3742C7.15578 10.3742 5.87022 9.08868 5.87022 7.40757C5.87022 5.72646 7.15578 4.4409 8.83688 4.4409ZM13.1217 16.3076H4.55203C4.18713 16.3076 3.89245 16.0129 3.89245 15.648V15.3187C3.89245 13.7651 6.37653 12.352 8.83688 12.352C11.2972 12.352 13.7813 13.7651 13.7813 15.3187V15.648C13.7813 16.0129 13.4866 16.3076 13.1217 16.3076Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.16462d9072f7ac865efda8be5aeead0c.svg";
export { ForwardRef as ReactComponent };